import $http from '../../axios';
import {Notification} from 'element-ui';
import moment from 'moment';

/**
 * Listar proveedores.
 */
export async function fetchContacts({commit, state}, filter = '') {

    commit('setPreloader', true);

    let params = {
        paginate: false,
        filter: filter,
        id_provider: 1
    };

    await $http.get('/api/terceros-lite', {params})
        .then((response) => {
            commit('setPreloader', false);
            commit('setContacts', response.data.data);
        })
        .catch((error) => {
            commit('setPreloader', false);
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        });
}

/**
 * Listar líneas.
 */
export async function fetchLines({commit}) {

    commit('setPreloader', true);

    await $http.get('/api/lineas')
        .then(response => {
            commit('setPreloader', false);
            commit('setLines', response.data.data);
        })
        .catch(() => {
            commit('setPreloader', false);
        });
}

/**
 * Descargar reporte.
 */
export async function downloadReport({state, commit}) {
    commit('setPreloader', true);

    await $http({
        url: '/api/replacement-by-points-of-sale',
        params: state.filters,
        method: 'GET',
        responseType: 'blob',
    }).then(response => {
        commit('setPreloader', false);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let date = moment().format('YYYY-MM-DD hh-mm-ss');
        link.setAttribute('download', `Reposición de inventario por punto de venta ${date}.xlsx`);
        document.body.appendChild(link);
        link.click();
    }).catch(error => {
        commit('setPreloader', false);
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box'
        });
    });
}



// WEBPACK FOOTER //
// ./src/modules/replacement_points_of_sale/actions.js